<template>
  <div style="width: 100%; height: 100%">
    <div
      class="china-map"
      ref="chinaMap"
      style="width: 100%; height: 100%"
    ></div>
    <!-- <img src="@/assets/img/copy.png" alt=""> -->
  </div>
</template>
<script>
// 引入资源
import * as echarts from "echarts";
import china from "@/until/china.json";
let dian = [
  { name: "朱马店镇", value: [116.454858, 32.913925] },
  { name: "城关镇", value: [116.722615, 32.709243] },
  { name: "丁集镇", value: [116.6469973, 32.8283509] },
  { name: "顾桥镇", value: [116.545119, 32.834366] },
  { name: "顾桥镇临淝村", value: [116.55506, 32.79687] },
  { name: "顾桥镇搬迁安置区", value: [116.5468553777, 32.830945262] },
  { name: "凤凰镇", value: [116.720502, 32.709076] },
  { name: "泰安东岳大街", value: [117.114703, 36.189207] },
  { name: "万达广场", value: [117.087913, 36.180954] },
  { name: "济南市历下区经十路", value: [117.100243, 36.659148] },
];

export default {
  props: ["showInfo", "mapData"],
  data() {
    return {
      mapD: [],
      myChart:'',
      option: {
        tooltip: {
          show: true,
          triggerOn: "mousemove", //mousemove、click
          padding: [4, 8],
          borderWidth: 1,
          borderColor: "#409eff",
          backgroundColor: "rgba(255,255,255,0.7)",
          textStyle: {
            color: "#000000",
            fontSize: 13,
          },
          formatter: function (e) {
            return e.name;
          },
        },
        geo: [
          // 第一层
          {
            map: "china",
            z: 3,
            zoom: 1.2,
            aspectScale: 0.85,
            animationDurationUpdate: 0 /* 实现缩放、拖动同步且不卡顿 */,
            roam: true,
            top: "10%",
            layoutSize: "100%", //保持地图宽高比
            label: {
              show: true,
              color: "#fff",
            },
            regions: [
              {
                // 隐藏南海诸岛,因为顶层已经添加过了
                name: "南海诸岛",
                itemStyle: {
                  borderWidth: 0.5,
                  shadowBlur: 0,
                  borderColor: "#61aacb",
                  areaColor: "#104584",
                },
              },
            ],
            itemStyle: {
              borderColor: "#c8feff",
              borderWidth: 0.5,
              shadowBlur: 3,
              shadowColor: "#66edff",
              areaColor: "#0862db",
            },
            emphasis: {
              itemStyle: {
                shadowBlur: 10,
                borderWidth: 1,
                areaColor: "#2da9ff",
              },
              label: {
                show: true,
                color: "#ffffff",
              },
            },
            select: {
              itemStyle: {
                shadowBlur: 10,
                borderWidth: 1,
                areaColor: "#2da9ff",
              },
              label: {
                color: "#ffffff",
              },
            },
          },
          // 第二层
          {
            map: "china",
            z: 2,
            zoom: 1.2,
            aspectScale: 0.85,
            animationDurationUpdate: 0 /* 实现缩放、拖动同步且不卡顿 */,
            roam: false,
            silent: true,
            top: "10%",
            layoutSize: "100%", //保持地图宽高比
            regions: [
              {
                // 隐藏南海诸岛,因为顶层已经添加过了
                name: "南海诸岛",
                itemStyle: {
                  opacity: 0, // 为 0 时不绘制该图形
                },
                label: {
                  show: false,
                },
              },
            ],
            itemStyle: {
              borderColor: "#d8feff",
              borderWidth: 3,
              shadowBlur: 10,
              shadowColor: "#22a1ff",
              areaColor: "#0862db",
              shadowOffsetX: 0,
              shadowOffsetY: 8,
            },
          },
          // 第三层
          {
            map: "china",
            z: 1,
            zoom: 1.2,
            aspectScale: 0.85,
            animationDurationUpdate: 0 /* 实现缩放、拖动同步且不卡顿 */,
            top: "11.5%",
            silent: true,
            layoutSize: "100%", //保持地图宽高比
            itemStyle: {
              borderColor: "#c8feff",
              borderWidth: 1,
              shadowBlur: 0,
              shadowColor: "#99c4ff",
              areaColor: "#4ebaff",
            },
            regions: [
              {
                // 隐藏南海诸岛,因为顶层已经添加过了
                name: "南海诸岛",
                itemStyle: {
                  opacity: 0, // 为 0 时不绘制该图形
                },
                label: {
                  show: false,
                },
              },
            ],
          },
          // 第四层
          {
            map: "china",
            z: 0,
            zoom: 1.2,
            aspectScale: 0.85,
            animationDurationUpdate: 0 /* 实现缩放、拖动同步且不卡顿 */,
            top: "12%",
            silent: true,
            layoutSize: "100%", //保持地图宽高比
            itemStyle: {
              borderColor: "#66edff",
              borderWidth: 2,
              shadowBlur: 20,
              shadowColor: "#4d99ff",
              areaColor: "#1752ad",
              shadowOffsetX: 0,
              shadowOffsetY: 8,
            },
            regions: [
              {
                // 隐藏南海诸岛,因为顶层已经添加过了
                name: "南海诸岛",
                itemStyle: {
                  opacity: 0, // 为 0 时不绘制该图形
                },
                label: {
                  show: false,
                },
              },
            ],
          },
        ],
        series: "",
      },
    };
  },
  created() {},
  mounted() {
    this.myChart = echarts.init(this.$refs.chinaMap);
    this.chinaEchart();
    this.getMapDataDetails();
    setInterval(() => {
      this.getMapDataDetails();
    }, 10000);


  },
  methods: {
    //获取地图数据
    getMapDataDetails() {
      this.$http.getMapDataDetails().then((res) => {
        // console.log("地图数据111", res);
        if (res.data.code == 200) {
          this.mapD = res.data.data;
        
          this.myChart.setOption({
            series: [
              {
                name: "",
                type: "effectScatter",
                coordinateSystem: "geo",
                symbolSize: function (val) {
                  //此处数字可调整散点大小
                  return 14;
                },
                showEffectOn: "render",
                rippleEffect: {
                  brushType: "stroke",
                },
                hoverAnimation: false,
                label: {
                  normal: {
                    formatter: "{b}",
                    position: "right",
                    show: false,
                    color: "#fff",
                  },
                },
                itemStyle: {
                  normal: {
                    color: "#1DE9B6",
                    shadowBlur: 10,
                    shadowColor: "#1DE9B6",
                  },
                },
                zlevel: 1,
                //此处data渲染的就是地图的点位数据
                data: this.mapD.map(function (item) {
                  return {
                    name: item.name,
                    value: [item.value[0], item.value[1], 1], // 最后一个数字控制涟漪特效的大小
                  };
                }),
              },
            ], 
          });

          // console.log(this.option.series);
        }
      });
    },
    //打开弹窗
    showParentInfo(data) {
      this.$emit("showInfo", data);
    },
    // 方法
    chinaEchart() {
      var that = this;
      //注册地图，这个特别重要
      echarts.registerMap("china", china);
      let myChart = echarts.init(this.$refs.chinaMap);
      //echart 配制option
      var options = that.option;
      myChart.setOption(options);
      /* 缩放平移事件 */
      myChart.on("georoam", (params) => {
        let option = myChart.getOption(); //获得option对象
        let len = option.geo.length;
        if (params.zoom) {
          //捕捉到缩放时
          for (var i = 0; i < len; i++) {
            option.geo[i].center = option.geo[0].center;
            option.geo[i].zoom = option.geo[0].zoom;
          }
        } else {
          //捕捉到拖曳时
          for (var i = 0; i < len; i++) {
            option.geo[i].center = option.geo[0].center;
          }
        }
        myChart.setOption(option); //设置option
      });
      // 绑定点击事件
      myChart.on("click", function (params) {
        // console.log("被点击", params);
        if (params.seriesType === "effectScatter") {
          // 散点点击事件
          // console.log("散点被点击", params.dataIndex);
          that.showParentInfo(that.mapD[params.dataIndex].sosId);
          // 可以通过 params.data 获取散点的数据
        }
      });
    },
  },
};
</script>
<style scoped>
.china-map {
  width: 100%;
  height: 100%;
}
</style>